var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Menu',{attrs:{"showSubMenu":false}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-not-found"},[_c('span',{staticClass:"not-found"},[_vm._v(" 404")])])
}]

export { render, staticRenderFns }